require('dotenv').config();
/* eslint-disable max-len */

module.exports = {

  port: process.env.PORT, // Node.js app
  trustProxy: 'loopback', // https://expressjs.com/en/guide/behind-proxies.html
  siteUrl: process.env.SITE_URL, // SITE URL
  host: `localhost:${process.env.PORT}`,

  // SECURITY: client→server handshake key for the OTP-send endpoint. NON-secret app identifier (it
  // necessarily ships in the client bundle). It MUST NOT be the JWT signing secret — the login forms
  // previously sent encode(JWT_SECRET), which baked the real auth-signing secret into client.js
  // (token forgery). See sendVerificationSecureSms.js. Robust hardening later = server rate-limit.
  clientSmsKey: 'bh-web-client-otp-key-v1',

  api: {  // API Gateway
    clientUrl: '', // API URL to be used in the client-side code
    serverUrl: `http://localhost:${process.env.PORT}`, // API URL to be used in the server-side code
    apiEndpoint: process.env.API_ENDPOINT_URL,
    socketUrl: process.env.SOCKET_URL
  },

  // Frozen to English (primary), Spanish, French. Other locales' message files are kept on disk
  // (unreachable via the picker) so this can be reverted by re-adding codes here.
  locales: ['en-US', 'es', 'fr-FR'],

  analytics: { // Web analytics https://analytics.google.com/
    // Empty on purpose: real analytics is injected by the admin Marketing & Tracking module
    // (validated GTM/GA4/Ads/Pixel IDs in Html.js). The old React-Starter-Kit placeholder
    // 'UA-XXXXX-X' fired a broken gtag on every page — removed (tags.js skips when empty).
    googleTrackingId: '',
  },

  placeDetailURL: process.env.PLACE_DETAILS_URL,
  autoCompleteURL: process.env.PLACES_AUTOCOMPLETE_URL,
  distanceRouteURL : process.env.DISTANCE_ROUTE_URL,

  // SECURITY: server-only Google Maps key for the Places API (New, v1). Used by the LP "post a
  // project" address autocomplete proxy (src/core/lpApi/lpPlacesRoute.js) so the key never reaches
  // the browser. The existing app keys are Android-restricted (unusable server-side) — this is a
  // separate unrestricted / IP- or referrer-restricted key. Empty on dev → proxy degrades to empty
  // suggestions (the address field stays a plain manual text input). NEVER hardcode the key.
  googlePlacesServerKey: process.env.GOOGLE_PLACES_SERVER_KEY,

  profilePhotouploadDir: process.env.PROFILE_PHOTO_UPLOAD_DIR, // Profile photo upload
  categoryUploadDir: process.env.CATEGORY_PHOTO_UPLOAD_DIR, // category photo upload
  logoUploadDir: process.env.LOGO_PHOTO_UPLOAD_DIR, // Logo photo upload
  ogImageUploadDir: process.env.OG_IMAGE_UPLOAD_DIR, // OG Image Upload
  homepageUploadDir: process.env.HOMEPAGE_UPLOAD_DIR, // homepage photo upload
  staticpageUploadDir: process.env.STATICPAGE_UPLOAD_DIR, // staticpage photo upload
  contentPageUploadDir: process.env.CONTENTPAGE_UPLOAD_DIR, //Content page photo upload
  faviconUploadDir: process.env.FAVICON_UPLOAD_DIR, // favicon upload
  subCategoryUploadDir: process.env.SUB_CATEGORY_PHOTO_UPLOAD_DIR, // subCategory photo upload
  documentUploadDir: process.env.DOCUMENT_UPLOAD_DIR, // Document Upload
  kybDocUploadDir: process.env.KYB_DOC_UPLOAD_DIR || '/images/kyb/', // Company KYB documents (Large Projects)
  homePageCategoryBannerUploadDir: process.env.HOMEPAGE_CATEGORY_BANNER_UPLOAD_DIR, //homepagecategory images
  homePageCategoryLogoUploadDir: process.env.HOMEPAGE_CATEGORY_LOGO_UPLOAD_DIR,
  promoCodeImageUploadDir: process.env.PROMO_CODE_UPLOAD_DIR, //Promocode image directoy
  reviewImageUploadDir: process.env.REVIEW_PHOTO_UPLOAD_DIR,
  toneUploadDir: process.env.TONE_UPLOAD_DIR,
  cmsUploadDir: process.env.CMS_UPLOAD_DIR,
  countryFlagImageDir: process.env.COUNTRY_FLAG_IMAGE_DIR,

  searchLimit: 36,

  unitTypes: {
    km: { value: 'metric', convertFromMeter: 1000 },
    mile: { value: 'imperial', convertFromMeter: 1609 }
  },
  payment : { /* From ENV */
    payPal: {
      returnURL: `${process.env.SITE_URL}${process.env.PAYPAL_RETURN_URL}`,
      cancelURL: `${process.env.SITE_URL}${process.env.PAYPAL_CANCEL_URL}`,
      paymentSuccessURL: `${process.env.SITE_URL}${process.env.PAYPAL_PAYMENT_SUCCESS_URL}`,
      paymentCancelURL: `${process.env.SITE_URL}${process.env.PAYPAL_PAYMENT_CANCEL_URL}`,
      versions: {
        versionOne: '/v1',
        versionTwo: '/v2'
      },
      token_url: '/oauth2/token',
      payment_url: '/checkout/orders',
      capture_url: '/capture',
      payout_url: '/payments/payouts',
      refund: '/refund',
      refund_capture: '/payments/captures/'
    },
  }
};
